import { BinaryRealProperty } from "@1oo4/miv";
import { runAsync } from "../pages";

export class PictureManager {
    readonly image: HTMLImageElement;
    private url: string | undefined;

    constructor() {
        this.image = document.createElement("img");
        const self = this;
        this.image.onload = () => self.freeMemory();
    }

    async setPicture(data: BinaryRealProperty) {
        // error is ErrorMessage | undefined
        // value is Uint8Array<ArrayBufferLike> | undefined
        const [error, value] = await runAsync(data.FetchValueAsync(false));
        if (value !== undefined && value.length > 0) {
            let mimeType: string;
            if (value.length > 4 && value[0] === 0x89 && value[1] === 0x50 && value[2] === 0x4e && value[3] === 0x47) {
                mimeType = "image/png";
            } else if (value.length > 3 && value[0] === 0xff && value[1] === 0xd8 && value[2] === 0xff) {
                mimeType = "image/jpeg";
            } else {
                mimeType = "image/png";
            }
            const blob = new Blob([value as /*Uint8Array<ArrayBuffer>*/ BlobPart], { type: mimeType });
            this.freeMemory();
            this.url = URL.createObjectURL(blob);
            this.image.src = this.url;
        } else {
            // TODO broken image
            console.log("broken image");
            if (error === undefined) {
                console.log("(no error)")
            } else {
                console.log(error);
            }
        }
    }

    private freeMemory() {
        if (this.url !== undefined) {
            URL.revokeObjectURL(this.url);
            this.url = undefined;
        }
    }
}